import React, {Component} from "react";
import {
    Alert,
    Box,
    Container,
    Grid,
    TextareaAutosize,
    TextField,
    Typography
} from "@mui/material";
import postscribe from "postscribe"

import icon from '/assets/icon.png';
import {centerBoxStyle} from "app/modules/auth";
import {LoadingButton} from "@mui/lab";
import {inject, provider} from "react-ioc";
import {ApiClients} from "app/modules/external/services/AxiosBaseClient";
import {SaleStore} from "app/modules/external/sales/SalesStore";
import {observer} from "mobx-react";

const BreakElement = () => <div>
    <br/>
    <br/>
</div>

@provider(ApiClients)
@provider(SaleStore)
@observer
export class Index extends Component<any, any> {
    @inject salesStore: SaleStore;

    render() {
        if(this.salesStore.isRequestSent) {
            return <Box sx={centerBoxStyle}>
                <Alert sx={{ mt: 2, mb: 2 }} severity="success">Your request has been sent, you will be reached out shortly! Thank you for your Enquiry!</Alert>
            </Box>;
        }

        return <React.Fragment>
            <div id={"scripts"}></div>
            <Grid container sx={{ width: "100%", paddingTop: "20px" }}>
                <Grid item xs={12} textAlign={"center"} sx={{ pb: 8 }}>
                    <img src={icon} style={{ maxWidth: "200px", width: "100%", borderRadius: "20px" }}/>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h3" component="div" align={"center"} justifyContent={"center"} gutterBottom>Contact Sales Team</Typography>
                </Grid>
                <Grid item xs={0} md={2}></Grid>
                <Container component="main" maxWidth="xs">
                    <Box sx={centerBoxStyle}>
                        {this.salesStore.errorMessage && <Alert sx={{ width: "100%", mt: 2, mb: 2 }} severity="error">{this.salesStore.errorMessage}</Alert>}

                        <Box component="form" onSubmit={() => {}} noValidate sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                fullWidth
                                id="name"
                                label="Full Name"
                                name="name"
                                autoComplete="name"
                                autoFocus
                                value={this.salesStore.formState.$.fullName.value}
                                error={this.salesStore.formState.$.fullName.hasError}
                                helperText={this.salesStore.formState.$.email.error}
                                onChange={(e) => this.salesStore.formState.$.fullName.onChange(e.target.value)}
                            />
                            <TextField
                                margin="normal"
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                autoFocus
                                value={this.salesStore.formState.$.email.value}
                                error={this.salesStore.formState.$.email.hasError}
                                helperText={this.salesStore.formState.$.email.error}
                                onChange={(e) => this.salesStore.formState.$.email.onChange(e.target.value)}
                            />
                            <TextField
                                margin="normal"
                                fullWidth
                                id="phone"
                                label="Phone"
                                name="phone"
                                autoComplete="phone"
                                autoFocus
                                value={this.salesStore.formState.$.phone.value}
                                error={this.salesStore.formState.$.phone.hasError}
                                helperText={this.salesStore.formState.$.phone.error}
                                onChange={(e) => this.salesStore.formState.$.phone.onChange(e.target.value)}
                            />
                            <TextareaAutosize
                                minRows={5}
                                style={{ width: "100%" }}
                                value={(this.salesStore.formState.$.text.value || '')}
                                onChange={(e) => this.salesStore.formState.$.text.onChange(e.target.value)}
                            />
                            <LoadingButton
                                fullWidth
                                loading={this.salesStore.isLoading}
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={this.salesStore.submitEnquiry}
                            >
                                Send Enquiry
                            </LoadingButton>
                        </Box>
                    </Box>
                </Container>
                <Grid item xs={0} md={2}></Grid>
                <Grid item xs={12} textAlign={"center"}>
                    Ⓒ {new Date().getFullYear()} OnLogixs
                    <BreakElement/>
                </Grid>
            </Grid>
        </React.Fragment>;
    }

    componentDidMount() {
        postscribe('#scripts', '<script src="https://www.google.com/recaptcha/api.js?render=6Le9UDEhAAAAALyTfAqjHqWmU7CbWYHranRY1ly8" async defer></script>');
    }
}
